import { MenuIcon, XIcon } from "@heroicons/react/outline";
import { IconButton } from "@mui/material";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const Sidebar = ({ active }) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      {!isOpen ? (
        <MenuIcon
          className="fixed z-20 w-6 h-6 cursor-pointer sm:top-9 md:top-12 top-9 right-10 xl:hidden"
          onClick={() => {
            setIsOpen(true);
          }}
        />
      ) : (
        <XIcon
          onClick={() => {
            setIsOpen(false);
          }}
          className="fixed z-20 w-6 h-6 cursor-pointer sm:top-9 md:top-12 top-9 right-10"
        />
      )}
      <div
        // style={styles}
        className={`fixed shadow-2xl top-0 right-0 bg-white  z-10 h-full md:p-12 ease-in-out duration-500 transition-all p-8 sm:p-10
          ${isOpen ? "translate-x-0" : "translate-x-full"}
          ${isOpen ? "opacity-100" : "opacity-30"}
          `}
      >
        <div className="bg-opacity-100 mt-11">
          <a onClick={() => navigate("/content-creators")}>
            <p
              className={`p-3 xl:-mt-0 text-[#1b0c3e] 
              ${active === "contentCreators" ? "text-[#fff]" : "text-[#1b0c3e]"}
               ${active === "contentCreators" ? "bg-[#508dff]" : "bg-[#fff]"}
                font-semibold my-3 hover:bg-[#508dff] hover:text-white
                 rounded-md mb-1 text-xl cursor-pointer  lg:p-4  transition-all duration-200 ease-out`}
            >
              Who its for
            </p>
          </a>
          <a onClick={() => navigate("/pricing")}>
            <p
              className={`
              ${active === "pricing" ? "text-[#fff]" : "text-[#1b0c3e]"}
               ${active === "pricing" ? "bg-[#508dff]" : "bg-[#fff]"}
               font-semibold hover:bg-[#508dff] hover:text-white my-3
               transition-all duration-200 ease-out p-3 text-xl  mb-1 text-[#1b0c3e]  rounded-md cursor-pointer lg:p-4`}
            >
              Pricing
            </p>
          </a>
          <Link to="/how-it-works">
            <p
              className={`
              ${active === "howItWorks" ? "text-[#fff]" : "text-[#1b0c3e]"}
               ${active === "howItWorks" ? "bg-[#508dff]" : "bg-[#fff]"}
               font-semibold hover:bg-[#508dff] hover:text-white my-3
              p-3 text-[#1b0c3e] transition-all duration-200 ease-out mb-1 text-xl rounded-md cursor-pointer lg:p-4  xl:mb-0`}
            >
              How it works
            </p>
          </Link>
          <Link to="/reviews">
            <p
              className={`
              ${active === "reviews" ? "text-[#fff]" : "text-[#1b0c3e]"}
               ${active === "reviews" ? "bg-[#508dff]" : "bg-[#fff]"}
               font-semibold hover:bg-[#508dff] hover:text-white my-3
               p-3 text-[#1b0c3e] transition-all duration-200 ease-out mb-1 text-xl  rounded-md cursor-pointer lg:p-4  xl:mb-0
            `}
            >
              Reviews
            </p>
          </Link>
          <a onClick={() => navigate("/about")}>
            <p
              className={`p-3 transition-all duration-200 ease-out text-[#1b0c3e]  mb-1 text-xl       
              ${active === "about" ? "text-[#fff]" : "text-[#1b0c3e]"}
               ${active === "about" ? "bg-[#508dff]" : "bg-[#fff]"}
               font-semibold hover:bg-[#508dff] hover:text-white my-3               
               mb-1  text-xl 
               rounded-md cursor-pointer lg:p-4  xl:mb-0`}
            >
              About us
            </p>
          </a>
          <Link to="/contact-us">
            <p
              className={`
              ${active === "contact" ? "text-[#fff]" : "text-[#1b0c3e]"}
              ${active === "contact" ? "bg-[#508dff]" : "bg-[#fff]"}
            font-semibold hover:bg-[#508dff] hover:text-white my-3
            p-3 text-[#1b0c3e] transition-all duration-200 ease-out mb-1 text-xl  rounded-md cursor-pointer lg:p-4  xl:mb-0
            `}
            >
              Contact us
            </p>
          </Link>
          {/* <a href="">
            <p className="p-3 bg-[#f8cc84]   transition-all duration-200 ease-out text-[#1b0c3e] px-6 text-xl hover:opacity-60 font-semibold rounded-md cursor-pointer sm:p-4 xl:mb-0 ">
              Dashbord login
            </p>
          </a> */}
        </div>
      </div>
    </>
  );
};

export default Sidebar;
